import create, { SetState, StateCreator, StoreApi } from "zustand";


interface userManagmentStore {
    userRole: string;
    setUserRole: (x: any) => void;
}

let store: StateCreator<userManagmentStore, [], [], userManagmentStore> | StoreApi<userManagmentStore> = (set: SetState<userManagmentStore>) => ({
    userRole: '',
    setUserRole: (x) => {
      set(() => ({ userRole: x }));
    },
    clearStore: () => {
        set(() => ({ userRole: '' }));
      },
})

export const useUserManagement = create(store);